<template>
    <div>
        <div id="menu-main" class="menu menu-box-right menu-box-detached rounded-m" data-menu-width="320" data-menu-active="nav-welcome" data-menu-effect="menu-over" style="display: block; width: 320px;">
            <div class="menu-header justify-content-center mb-0">
                <button class="close-menu" id="closeMenuBtn"><i class="fa font-20 fa-times color-dark1-light"></i></button>
                <div>
                    <div class="text-center mt-2 brand-color">
                        <span v-if="isKarnegasht==true">کارنگاشت </span>
                        <span v-if="isKarnegasht==false">تسکینو </span>
                        نسخه شماره  {{appVersionCode}}
                    </div>
                    <div v-if="isFreeVersion==true" class="text-center brand-color font-10" style="margin-top:-4px"> Free Installation </div>
                </div>

            </div>
            <div class="menu-logo text-center">
                <div class="d-flex p-2">
                    <div class="d-flex align-items-center">
                        <i v-if="UserImg==null || UserImg==''" class="fa fa-user-circle color-green1-dark fa-5x icon-size"></i>
                        <img v-else v-bind:src="UserImg" alt="Alternate Text" width="65" height="65" class="img-fluid rounded-circle ml-3" />

                    </div>
                    <div class="d-flex flex-column justify-content-center">
                        <h1 class="mt-0 mb-1 font-weight-bolder font-18 text-right">{{UserFullName}}</h1>
                        <p class="mb-0 text-right">امروز: {{todayDate}}</p>
                        <p v-if="isMinVersion==true" class="mb-0 d-flex justify-content-between">
                            <span class="ml-1">اعتبار حساب تا :</span>
                            <span class="d-inline-block ltr">{{expireDate}}</span>
                        </p>

                    </div>
                </div>
            </div>
            <div class="divider my-2"></div>
            <div class="menu-items">

                <div class="nav-item-active lightModeBtn position-relative" v-if="isMinVersion==true && isKarnegasht==faslse" @click.prevent="WalletAlertTaskino()">
                    <i class="fa fa-dollar-sign text-warning"></i>
                    <span>موجودی کیف پول <span>{{walletRemain.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span> تومان</span>
                </div>
                <div class="nav-item-active lightModeBtn position-relative" v-if="isMinVersion==true && isKarnegasht==true" @click.prevent="WalletAlertKarnegasht()">
                    <i class="fa fa-dollar-sign text-warning"></i>
                    <span>موجودی کیف پول <span>{{walletRemain.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span> تومان</span>
                </div>
                <button class="nav-item-active distinct-nav-item" @click.prevent="CopyRegisterLinkTaskino" v-if="isMinVersion==true && isKarnegasht==faslse" style="background-color: #528edd !important ">
                    <i class="fa fa-copy brand-color mt-1"></i>
                    <span>کپی لینک دعوت با کد معرف</span>
                </button>
                <button class="nav-item-active distinct-nav-item" @click.prevent="CopyRegisterLinkKarnegasht" v-if="isMinVersion==true && isKarnegasht==true" style="background-color: #528edd !important ">
                    <i class="fa fa-copy brand-color mt-1"></i>
                    <span>کپی لینک دعوت با کد معرف</span>
                </button>
                <div class="nav-item-active lightModeBtn position-relative">
                    <i class="fa fa-lightbulb text-warning"></i>
                    <span data-activate="toggle-dark">حالت تاریک</span>
                    <div class="custom-control ios-switch darkMode-switch">
                        <input data-toast="switched-color-scheme" data-toggle-theme-switch type="checkbox" class="ios-input" id="toggle-dark">
                        <label class="custom-control-label" for="toggle-dark"></label>
                    </div>
                </div>
                <router-link id="nav-welcome" to="/UserProfile" class="nav-item-active">
                    <i class="fa fa-user-circle color-green1-dark"></i>
                    <span>پروفایل کاربری</span>
                </router-link>
                <router-link id="nav-welcome" to="/About" class="nav-item-active">
                    <i class="fa fa-info-circle color-magenta1-light"></i>
                    <span>درباره</span>
                </router-link>

                <router-link id="nav-welcome" to="/NotificationList" class="nav-item-active">
                    <i class="fa fa-comment-alt color-yellow1-light"></i>
                    <span>پیام ها</span>
                </router-link>
                <router-link id="nav-welcome" to="/UpdatesPage" class="nav-item-active">
                    <i class="fa fa-bullhorn color-mint-dark"></i>
                    <span>بروزرسانی‌ها</span>
                </router-link>
                <router-link id="nav-welcome" to="/AppUpdate" class="nav-item-active" v-if="this.isFreeVersion==false">
                    <i class="fa fa-download color-blue1-dark"></i>
                    <span>دانلود آخرین نسخه</span>
                </router-link>
                <router-link id="nav-welcome" to="/PrivacyPolicy" class="nav-item-active">
                    <i class="fa fa-shield-alt color-brown1-dark"></i>
                    <span>سیاست حفظ حریم خصوصی</span>
                </router-link>
                <router-link id="nav-welcome" to="/ChangePass" class="nav-item-active">
                    <i class="fa fa-lock color-orange-dark"></i>
                    <span>تغییر رمز عبور</span>
                </router-link>
                <a id="nav-welcome" href="#" @click.prevent="SignOutUser()">
                    <i class="fa fa-sign-out-alt color-red1-dark"></i>
                    <span class="font-weight-bold">خروج</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    export default {
        data() {
            return {
                info: null,
                todayDate: null,
                walletRemain: 0,
                expireDate: null
            }
        },
        computed: {
            IsUserAuthenticated() {
                return this.$store.getters.IsUserAuthenticated;
            },
            UserFullName() {
                return this.$store.getters.GetUserFullName;
            },
            isAdmin() {
                return this.$store.getters.GetIsAdmin;
            },
            UserImg() {
                return this.$store.getters.GetUserImg;
            },
            isMinify() {
                return true;
            }
        },
        methods: {
            CopyRegisterLinkTaskino() {
                try {
                    this.$http.get("TaskOnline/GetLogginedUserCode")
                        .then(data => {
                            navigator.clipboard.writeText("https://mobile.taskinoapp.com/register/" + data.data);
                            document.getElementById("closeMenuBtn").click();
                            VueSimpleAlert.fire({
                                title: 'لینک دعوت به تسکینو با کد معرف کاربر شما کپی شد.',
                                showCancelButton: false,
                                confirmButtonText: 'تأیید',
                            })
                        });

                } catch ($e) {
                    alert('Cannot copy');
                }
            },
            CopyRegisterLinkKarnegasht() {
                try {
                    this.$http.get("TaskOnline/GetLogginedUserCode")
                        .then(data => {
                            navigator.clipboard.writeText("https://mobile.karnegasht.com/register/" + data.data);
                            document.getElementById("closeMenuBtn").click();
                            VueSimpleAlert.fire({
                                title: 'لینک دعوت به کارنگاشت با کد معرف کاربر شما کپی شد.',
                                showCancelButton: false,
                                confirmButtonText: 'تأیید',
                            })
                        });

                } catch ($e) {
                    alert('Cannot copy');
                }
            },
            GetExpireDate() {

                this.$http.get("Account/GetUserExpireDate")
                    .then(data => {
                        this.expireDate = data.data;
                        if (this.expireDate != null && this.expireDate != "")
                            this.expireDate = this.expireDate.substring(0, 10)
                    });
            },
            GetWalletPayable() {

                this.$http.get("Account/GetWalletPayable")
                    .then(data => {
                        this.walletRemain = data.data;
                    });
            },
            GetCurrentDate() {
                this.$http.get("Account/GetCurrenctDateTime")
                    .then(data => {
                        this.todayDate = data.data;
                    });
            },
            CheckForLogin() {
                if (this.$route.path != '/register') {
                    this.$store.dispatch("CheckForLogin");
                }
            },
            SignOutUser() {
                this.$store.dispatch("SignOutUser");
            },
            WalletAlertTaskino() {
                document.getElementById("closeMenuBtn").click();
                VueSimpleAlert.fire({
                    title: 'برای مشاهده جزئیات موجودی کیف پول به نسخه دسکتاپ به نشانی اینترنتی https://web.taskinoapp.com مراجعه نمایید.',
                    showCancelButton: false,
                    confirmButtonText: 'تأیید',
                })
            },
            WalletAlertKarnegasht() {
                document.getElementById("closeMenuBtn").click();
                VueSimpleAlert.fire({
                    title: 'برای مشاهده جزئیات موجودی کیف پول به نسخه دسکتاپ به نشانی اینترنتی https://web.karnegasht.com مراجعه نمایید.',
                    showCancelButton: false,
                    confirmButtonText: 'تأیید',
                })
            },

        },
        created() {
            this.CheckForLogin();
            this.GetCurrentDate();
            this.GetExpireDate();
            this.GetWalletPayable();
        }
    };
</script>
